// src/pages/MyReflection/MyReflection.jsx
import "../../styles/myreflection.css";
import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import useMyReflection from "./useMyReflection";

/* ═══════════════════════════════════════════════════════════
   INLINE PREMIUM POPUP  (portal → always screen-centered)
═══════════════════════════════════════════════════════════ */
const _popupCSS = `
@keyframes sp-overlay-in{from{opacity:0}to{opacity:1}}
@keyframes sp-card-in{from{opacity:0;transform:scale(0.55) translateY(28px)}to{opacity:1;transform:scale(1) translateY(0)}}
@keyframes sp-circle-draw{to{stroke-dashoffset:0}}
@keyframes sp-tick-draw{to{stroke-dashoffset:0}}
@keyframes sp-glow-pulse{0%,100%{opacity:.65;transform:scale(1)}50%{opacity:1;transform:scale(1.13)}}
@keyframes sp-burst{0%{opacity:1;transform:translate(0,0) scale(1)}100%{opacity:0;transform:translate(var(--tx,20px),var(--ty,-28px)) scale(.2)}}
@keyframes sp-progress{from{transform:scaleX(1)}to{transform:scaleX(0)}}
.sp-overlay{position:fixed!important;inset:0!important;background:rgba(8,12,26,.62);backdrop-filter:blur(7px);-webkit-backdrop-filter:blur(7px);z-index:9999999!important;display:flex!important;align-items:center!important;justify-content:center!important;animation:sp-overlay-in .18s ease}
.sp-card{position:relative;background:linear-gradient(150deg,#fff 0%,#f5f8ff 100%);border-radius:26px;padding:46px 38px 34px;width:360px;max-width:92vw;text-align:center;overflow:hidden;box-shadow:0 0 0 1.5px rgba(255,255,255,.85) inset,0 28px 70px rgba(0,0,0,.18),0 0 55px var(--sp-glow,rgba(34,197,94,.22));animation:sp-card-in .38s cubic-bezier(.34,1.56,.64,1);border:1.5px solid rgba(255,255,255,.65)}
.sp-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:var(--sp-accent,#22c55e);border-radius:26px 26px 0 0}
.sp-card::after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse at 20% 0%,var(--sp-glow,rgba(34,197,94,.13)) 0%,transparent 60%),radial-gradient(ellipse at 80% 100%,var(--sp-glow,rgba(34,197,94,.08)) 0%,transparent 60%);pointer-events:none;border-radius:26px}
.sp-icon-ring{position:relative;width:88px;height:88px;margin:0 auto 18px}
.sp-icon-glow{position:absolute;inset:-8px;background:var(--sp-glow,rgba(34,197,94,.28));border-radius:50%;filter:blur(13px);animation:sp-glow-pulse 2s ease-in-out infinite}
.sp-svg{position:relative;z-index:1;width:88px;height:88px}
.sp-circle{stroke:var(--sp-accent,#22c55e);stroke-width:2.5;stroke-dasharray:166;stroke-dashoffset:166;stroke-linecap:round;fill:none;animation:sp-circle-draw .6s cubic-bezier(.65,0,.45,1) .1s forwards}
.sp-tick{stroke:var(--sp-accent,#22c55e);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:50;stroke-dashoffset:50;fill:none;animation:sp-tick-draw .38s ease .55s forwards}
.sp-sparkles{position:absolute;top:88px;left:50%;transform:translateX(-50%);width:96px;height:96px;pointer-events:none}
.sp-dot{position:absolute;left:50%;top:50%;width:7px;height:7px;border-radius:50%;background:var(--sp-accent,#22c55e);opacity:0}
.sp-d1{animation:sp-burst .65s ease .6s forwards;--tx:-24px;--ty:-30px}
.sp-d2{animation:sp-burst .65s ease .65s forwards;--tx:22px;--ty:-26px}
.sp-d3{animation:sp-burst .65s ease .7s forwards;--tx:-34px;--ty:7px}
.sp-d4{animation:sp-burst .65s ease .72s forwards;--tx:32px;--ty:5px}
.sp-d5{animation:sp-burst .65s ease .68s forwards;--tx:-17px;--ty:26px}
.sp-d6{animation:sp-burst .65s ease .75s forwards;--tx:19px;--ty:24px}
.sp-label{font-family:"Segoe UI","SF Pro Display",system-ui,sans-serif;font-size:21px;font-weight:800;color:#1a202c;letter-spacing:-.3px;margin-bottom:9px;position:relative;z-index:1}
.sp-msg{font-family:"Segoe UI",system-ui,sans-serif;font-size:14px;color:#64748b;line-height:1.6;margin:0 0 24px;position:relative;z-index:1}
.sp-btn{display:inline-flex;align-items:center;gap:8px;background:var(--sp-accent,#22c55e);color:#fff;border:none;border-radius:11px;padding:11px 26px;font-size:14px;font-weight:700;letter-spacing:.3px;cursor:pointer;position:relative;z-index:1;transition:transform .15s,box-shadow .15s;box-shadow:0 6px 18px var(--sp-glow,rgba(34,197,94,.38))}
.sp-btn:hover{transform:translateY(-2px);box-shadow:0 10px 26px var(--sp-glow,rgba(34,197,94,.48))}
.sp-btn-ghost{display:inline-flex;align-items:center;gap:6px;background:transparent;color:#64748b;border:1.5px solid #e2e8f0;border-radius:11px;padding:10px 22px;font-size:14px;font-weight:600;cursor:pointer;position:relative;z-index:1;transition:background .15s,color .15s}
.sp-btn-ghost:hover{background:#f1f5f9;color:#1a202c}
.sp-btn-row{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;position:relative;z-index:1}
.sp-progress{position:absolute;bottom:0;left:0;height:3px;width:100%;background:var(--sp-accent,#22c55e);opacity:.45;border-radius:0 0 26px 26px;transform-origin:left;animation:sp-progress 3.5s linear forwards}
`;

function _injectStyles() {
  if (!document.getElementById("sp-styles-mr")) {
    const tag = document.createElement("style");
    tag.id = "sp-styles-mr";
    tag.textContent = _popupCSS;
    document.head.appendChild(tag);
  }
}

const SP_CFG = {
  success: { accent: "#22c55e", glow: "rgba(34,197,94,.25)"  },
  error:   { accent: "#ef4444", glow: "rgba(239,68,68,.22)"  },
  warning: { accent: "#f59e0b", glow: "rgba(245,158,11,.22)" },
  info:    { accent: "#3b82f6", glow: "rgba(59,130,246,.22)" },
};

function PremiumPopup({ popup, onClose }) {
  useEffect(() => { _injectStyles(); }, []);

  useEffect(() => {
    if (!popup) return;
    if (popup.type === "success" || popup.type === "info") {
      const t = setTimeout(onClose, 3500);
      return () => clearTimeout(t);
    }
  }, [popup, onClose]);

  if (!popup) return null;
  const cfg = SP_CFG[popup.type] || SP_CFG.success;
  const isSuccess = popup.type === "success";
  const isError   = popup.type === "error";

  return ReactDOM.createPortal(
    <div className="sp-overlay" onClick={onClose}>
      <div className="sp-card"
        style={{ "--sp-accent": cfg.accent, "--sp-glow": cfg.glow }}
        onClick={e => e.stopPropagation()}
      >
        <div className="sp-icon-ring">
          <div className="sp-icon-glow" />
          <svg className="sp-svg" viewBox="0 0 52 52">
            <circle className="sp-circle" cx="26" cy="26" r="25" />
            {isSuccess && <path className="sp-tick" fill="none" d="M14 27l9 9 15-18" />}
            {isError   && <path className="sp-tick" fill="none" strokeWidth="3" d="M17 17 35 35M35 17 17 35" />}
            {!isSuccess && !isError && <path className="sp-tick" fill="none" strokeWidth="3.5" d="M26 16v14M26 35v2" />}
          </svg>
        </div>
        <div className="sp-sparkles">
          <span className="sp-dot sp-d1"/><span className="sp-dot sp-d2"/>
          <span className="sp-dot sp-d3"/><span className="sp-dot sp-d4"/>
          <span className="sp-dot sp-d5"/><span className="sp-dot sp-d6"/>
        </div>
        <div className="sp-label">{popup.title}</div>
        {popup.message && <p className="sp-msg">{popup.message}</p>}
        <button className="sp-btn" onClick={onClose}>
          Got it &nbsp;
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </button>
        {(popup.type === "success" || popup.type === "info") && <div className="sp-progress" />}
      </div>
    </div>,
    document.body
  );
}

function ConfirmPopup({ confirm, onCancel }) {
  useEffect(() => { _injectStyles(); }, []);
  if (!confirm) return null;

  return ReactDOM.createPortal(
    <div className="sp-overlay" onClick={onCancel}>
      <div className="sp-card"
        style={{ "--sp-accent": "#ef4444", "--sp-glow": "rgba(239,68,68,.22)" }}
        onClick={e => e.stopPropagation()}
      >
        <div className="sp-icon-ring">
          <div className="sp-icon-glow" />
          <svg className="sp-svg" viewBox="0 0 52 52">
            <circle className="sp-circle" cx="26" cy="26" r="25"
              style={{ stroke: "#ef4444" }} />
            <path className="sp-tick" fill="none" strokeWidth="3.5"
              d="M26 16v14M26 35v2"
              style={{ stroke: "#ef4444" }} />
          </svg>
        </div>
        <div className="sp-label" style={{ color: "#ef4444" }}>Are you sure?</div>
        <p className="sp-msg">{confirm.message}</p>
        <div className="sp-btn-row">
          <button className="sp-btn"
            style={{ "--sp-accent": "#ef4444", "--sp-glow": "rgba(239,68,68,.35)",
                     background: "#ef4444" }}
            onClick={confirm.onConfirm}
          >
            🗑 Yes, Delete
          </button>
          <button className="sp-btn-ghost" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
/* ═══════════════════════════════════════════════════════════ */

const getCardGradient = (index) => {
  const gradients = [
    "linear-gradient(135deg, #00d4ff, #9d4edd)",
    "linear-gradient(135deg, #9d4edd, #ff4d8d)",
    "linear-gradient(135deg, #00ffab, #00d4ff)",
    "linear-gradient(135deg, #ff4d8d, #ffd700)",
    "linear-gradient(135deg, #ffd700, #00ffab)",
  ];
  return gradients[index % gradients.length];
};

const getPeriodIcon = (type) => {
  switch (type) {
    case "daily":   return "☀️";
    case "weekly":  return "📅";
    case "monthly": return "📊";
    default:        return "📝";
  }
};

const formatDisplayDate = (rec) => {
  try {
    if (rec.PeriodType === "daily" || rec.PeriodType === "weekly") {
      return rec.SelectedDate ? new Date(rec.SelectedDate).toLocaleDateString("en-GB") : "-";
    }
    if (rec.PeriodType === "monthly") {
      return rec.MonthName && rec.Year ? `${rec.MonthName} ${rec.Year}` : "-";
    }
    return rec.DateSubmitted ? new Date(rec.DateSubmitted).toLocaleDateString("en-GB") : "-";
  } catch {
    return "-";
  }
};

export default function MyReflection() {
  const {
    period, setPeriod,
    records,
    selectedCard,
    loading,
    error,
    isEditing,
    editQ1, setEditQ1,
    editQ2, setEditQ2,
    editQ3, setEditQ3,
    successPopup, setSuccessPopup,
    confirmPopup, setConfirmPopup,
    openCardDetails,
    closeCardDetails,
    startEditing,
    saveUpdatedReflection,
    deleteReflection,
  } = useMyReflection();

  // ================= PAGINATION =================
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const sortedRecords = [...records].sort(
    (a, b) => new Date(b.DateSubmitted) - new Date(a.DateSubmitted)
  );
  const lastIndex        = currentPage * itemsPerPage;
  const firstIndex       = lastIndex - itemsPerPage;
  const paginatedRecords = sortedRecords.slice(firstIndex, lastIndex);
  const totalPages       = Math.ceil(sortedRecords.length / itemsPerPage);

  // Prevent body scroll when modal open
  useEffect(() => {
    if (selectedCard) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [selectedCard]);

  // ================= DETAIL MODAL =================
  const renderModal = () => {
    if (!selectedCard) return null;

    return ReactDOM.createPortal(
      <div className="coin-card-details">
        <div className="details-content">
          <button className="details-close-btn" onClick={closeCardDetails}>×</button>

          <div
            className="mr-card expanded"
            style={{ "--status-color": getCardGradient(selectedCard.index) }}
          >
            <div className="card-status-bar"></div>

            <div className="mr-card-header">
              <div className="card-header-content">
                <div className="mr-avatar-wrapper">
                  <div
                    className="mr-avatar"
                    style={{ background: getCardGradient(selectedCard.index) }}
                  >
                    {selectedCard.Name?.charAt(0).toUpperCase()}
                  </div>
                </div>

                <div className="user-info">
                  <h3 className="mr-name">{selectedCard.Name}</h3>
                  <div
                    className="period-tag"
                    style={{ background: getCardGradient(selectedCard.index) }}
                  >
                    {getPeriodIcon(selectedCard.PeriodType)} {selectedCard.PeriodType}
                  </div>
                </div>

                <div className="date-info">
                  <div className="date-badge">📅 {formatDisplayDate(selectedCard)}</div>
                  <div className="reflection-id">ID: {selectedCard.ReflectionID}</div>
                </div>
              </div>

              <div className="modal-action-buttons">
                {!isEditing && (
                  <button className="modal-edit-btn" onClick={startEditing}>
                    ✏️ Edit
                  </button>
                )}
                <button className="modal-delete-btn" onClick={deleteReflection}>
                  🗑 Delete
                </button>
              </div>
            </div>

            {/* ── EDIT MODE ── */}
            {isEditing ? (
              <div className="mr-card-body elegant-edit-area">

                {/* Question 1 */}
                <div className="edit-block">
                  <div className="edit-block-header">
                    <span className="edit-q-number">1</span>
                    <span className="edit-q-title">
                      {selectedCard.Answers?.Question1?.question || "Question 1"}
                    </span>
                  </div>
                  {editQ1.map((ans, i) => (
                    <div key={i} className="answer-line">
                      <textarea
                        className="edit-textarea-glass"
                        value={ans}
                        onChange={(e) => {
                          const updated = [...editQ1];
                          updated[i] = e.target.value;
                          setEditQ1(updated);
                        }}
                      />
                      <button
                        className="delete-answer-btn"
                        onClick={() => setEditQ1(editQ1.filter((_, idx) => idx !== i))}
                      >✖</button>
                    </div>
                  ))}
                  <button className="add-answer-btn" onClick={() => setEditQ1([...editQ1, ""])}>
                    ➕ Add Answer
                  </button>
                </div>

                {/* Question 2 */}
                <div className="edit-block">
                  <div className="edit-block-header">
                    <span className="edit-q-number">2</span>
                    <span className="edit-q-title">
                      {selectedCard.Answers?.Question2?.question || "Question 2"}
                    </span>
                  </div>
                  {editQ2.map((ans, i) => (
                    <div key={i} className="answer-line">
                      <textarea
                        className="edit-textarea-glass"
                        value={ans}
                        onChange={(e) => {
                          const updated = [...editQ2];
                          updated[i] = e.target.value;
                          setEditQ2(updated);
                        }}
                      />
                      <button
                        className="delete-answer-btn"
                        onClick={() => setEditQ2(editQ2.filter((_, idx) => idx !== i))}
                      >✖</button>
                    </div>
                  ))}
                  <button className="add-answer-btn" onClick={() => setEditQ2([...editQ2, ""])}>
                    ➕ Add Answer
                  </button>
                </div>

                {/* Question 3 */}
                <div className="edit-block">
                  <div className="edit-block-header">
                    <span className="edit-q-number">3</span>
                    <span className="edit-q-title">
                      {selectedCard.Answers?.Question3?.question || "Question 3"}
                    </span>
                  </div>
                  {editQ3.map((ans, i) => (
                    <div key={i} className="answer-line">
                      <textarea
                        className="edit-textarea-glass"
                        value={ans}
                        onChange={(e) => {
                          const updated = [...editQ3];
                          updated[i] = e.target.value;
                          setEditQ3(updated);
                        }}
                      />
                      <button
                        className="delete-answer-btn"
                        onClick={() => setEditQ3(editQ3.filter((_, idx) => idx !== i))}
                      >✖</button>
                    </div>
                  ))}
                  <button className="add-answer-btn" onClick={() => setEditQ3([...editQ3, ""])}>
                    ➕ Add Answer
                  </button>
                </div>

                <button onClick={saveUpdatedReflection} className="save-btn-final">
                  💾 Save Changes
                </button>
              </div>

            ) : (
              /* ── VIEW MODE ── */
              <div className="mr-card-body">
                <div className="reflection-content">

                  <div className="question-block">
                    <div className="question-header">
                      <div className="question-number">1</div>
                      <div className="question-text">
                        {selectedCard.Answers?.Question1?.question}
                      </div>
                    </div>
                    <ul className="answer-list">
                      {(selectedCard.Answers?.Question1?.answers || []).map((a, i) => (
                        <li key={i} className="answer-item">• {a}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="question-block">
                    <div className="question-header">
                      <div className="question-number">2</div>
                      <div className="question-text">
                        {selectedCard.Answers?.Question2?.question}
                      </div>
                    </div>
                    <ul className="answer-list">
                      {(selectedCard.Answers?.Question2?.answers || []).map((a, i) => (
                        <li key={i} className="answer-item">• {a}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="question-block">
                    <div className="question-header">
                      <div className="question-number">3</div>
                      <div className="question-text">
                        {selectedCard.Answers?.Question3?.question}
                      </div>
                    </div>
                    <ul className="answer-list">
                      {(selectedCard.Answers?.Question3?.answers || []).map((a, i) => (
                        <li key={i} className="answer-item">• {a}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="card-footer">
                  <div className="submission-info">
                    ⏱️ Submitted on:{" "}
                    {selectedCard.DateSubmitted
                      ? new Date(selectedCard.DateSubmitted).toLocaleDateString("en-GB")
                      : "Unknown"}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <div className="mr-wrapper">
      <div className="mr-container">

        {/* Top Filter */}
        <div className="mr-top-filter">
          <div className="filter-left">
            <label className="period-label-ultra">
              <span className="period-icon">📅</span>
              PERIOD FILTER
            </label>
            <div className="filter-select-wrapper">
              <select
                value={period}
                onChange={(e) => {
                  setCurrentPage(1);
                  setPeriod(e.target.value);
                }}
                className="period-select-ultra"
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
          </div>

          {!loading && records.length > 0 && (
            <div className="filter-stats">
              Showing {records.length} reflection{records.length !== 1 ? "s" : ""}
            </div>
          )}
        </div>

        {/* Loading */}
        {loading && (
          <div className="loading-container-ultra">
            <div className="loader-ultra">
              <div className="loader-dot-ultra"></div>
              <div className="loader-dot-ultra"></div>
              <div className="loader-dot-ultra"></div>
            </div>
            <p className="loading-text-ultra">Loading reflections...</p>
          </div>
        )}

        {/* Error */}
        {error && (
          <div className="mr-error">
            <p>⚠️ {error}</p>
            <button onClick={() => window.location.reload()}>Try Again</button>
          </div>
        )}

        {/* Empty */}
        {!loading && records.length === 0 && !error && (
          <div className="empty-state-ultra">
            <div className="empty-icon">📝</div>
            <h3>No reflections found</h3>
            <p>Start capturing your thoughts in the Reflection tab!</p>
          </div>
        )}

        {/* Cards Grid */}
        {!loading && records.length > 0 && (
          <>
            <div className="mr-cards-grid-coin">
              {paginatedRecords.map((rec, index) => (
                <div
                  key={index}
                  className="coin-card"
                  style={{ "--card-gradient": getCardGradient(index) }}
                  onClick={() => openCardDetails(rec, index)}
                >
                  <div className="coin-card-divider"></div>
                  <div className="coin-card-content">
                    <div className="coin-card-user">{rec.Name}</div>
                    <div className="coin-card-meta">
                      <span className="meta-item">
                        {getPeriodIcon(rec.PeriodType)} {rec.PeriodType}
                      </span>
                      <span className="meta-separator">•</span>
                      <span className="meta-item">📅 {formatDisplayDate(rec)}</span>
                    </div>
                    <div className="coin-card-id">ID: {rec.ReflectionID}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {records.length > itemsPerPage && (
              <div style={{
                display: "flex", justifyContent: "center",
                alignItems: "center", marginTop: "25px", gap: "15px"
              }}>
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(p => p - 1)}
                  style={{
                    padding: "10px 18px", borderRadius: "10px", border: "none",
                    background: currentPage === 1 ? "#555" : "#00d4ff",
                    color: "white", cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    fontWeight: "700"
                  }}
                >⬅ Previous</button>

                <span style={{ color: "white", fontWeight: "800" }}>
                  Page {currentPage} / {totalPages}
                </span>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(p => p + 1)}
                  style={{
                    padding: "10px 18px", borderRadius: "10px", border: "none",
                    background: currentPage === totalPages ? "#555" : "#9d4edd",
                    color: "white", cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                    fontWeight: "700"
                  }}
                >Next ➡</button>
              </div>
            )}
          </>
        )}
      </div>

      {/* Detail modal */}
      {renderModal()}

      {/* Premium Popups — rendered at document.body via portal */}
      <PremiumPopup popup={successPopup} onClose={() => setSuccessPopup(null)} />
      <ConfirmPopup confirm={confirmPopup} onCancel={() => setConfirmPopup(null)} />
    </div>
  );
}